import {defineStore} from 'pinia'

export const useOpcoesStore = defineStore('opcoes',{

    state: () => {
        return {
            unidades: [],
            midias: [],        
            listaParentesco: [] ,
            escolasAnteriores: []
    }},
    actions: {
        async opcoesIniciaisInteresse(configuracoesInteresse) {
            this.unidades = configuracoesInteresse.configuracao.unidades;
            this.midias = configuracoesInteresse.midia;
            this.listaParentesco = configuracoesInteresse.parentesco;
            this.escolasAnteriores = configuracoesInteresse.escolaAnterior;
        }
    }
})